function CertifiedTaxExpert() {
  return (
    <section className="certified-tax-expert">
      {/* Row 1 & 2: Title and Description */}
      <div className="certified-expert-header">
        <h2 className="certified-expert-title">Who Files Your Taxes</h2>
        <p className="certified-expert-description">
          Every professional on Plaintr is verified and credentialed to file your taxes.
        </p>
      </div>

      {/* Row 3: Three Cards */}
      <div className="certified-expert-cards">
        <div className="certified-expert-card">
          <img src={`${process.env.PUBLIC_URL}/images/cpa_seal.svg`} alt="CPA Seal" className="certified-expert-card-image" />
          <p className="certified-expert-card-description">Certified Public Accountants (CPAs)</p>
        </div>
        <div className="certified-expert-card">
          <img src={`${process.env.PUBLIC_URL}/images/ea_seal.svg`} alt="EA Seal" className="certified-expert-card-image" />
          <p className="certified-expert-card-description">Enrolled Agents (EAs)</p>
        </div>
        <div className="certified-expert-card">
          <img src={`${process.env.PUBLIC_URL}/images/ta_seal.svg`} alt="Tax Attorney Seal" className="certified-expert-card-image" />
          <p className="certified-expert-card-description">Tax Attorneys</p>
        </div>
      </div>
    </section>
  );
}

export default CertifiedTaxExpert;

